<tax-rate>

    <span>
        { (props.tax_rate * 100) + "%" }
    </span>

    <script>
        export default {};
    </script>

</tax-rate>